import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import "./project.css"
import ScrollTop from '../components/ScrollTop';
import Work from '../components/Work';
import cert from "../images/cert.png"
import { pageAnimation, slider, sliderContainer } from '../utils/animation';
import img1 from "../images/Screenshot3.png"
import img2 from "../images/Screenshot2.png"
import img3 from "../images/Screenshot1.png"
import img4 from "../images/Screenshot4.png"
import img5 from "../images/screen.png"
import game from "../images/game.png"
import gamehub from "../images/gamehub.png"
import html from "../images/html.png"
import css from "../images/css.png"
import react from "../images/reactjs.png"
import fire from "../images/firebase.png"
import redux from "../images/redux.png"
import nodejs from "../images/nodejs.png"
import mongo from "../images/mongodb.png"
import ui from "../images/materialui.png"
import ex from "../images/ex.png"
import api from "../images/api.png"
import drive from "../images/drive.png"
import insta from "../images/insta1.png"
import meet from "../images/meet.png"
import key from "../images/key.png"
const MyWork = () => {
  return (
    <>
      <div className='project_section'>
      <div className='project'>
          <div className='pro_div'>
            <h1 className='pro_title'>Fitness Website(Full Stack)</h1>
            <div>
              <p className='pro_des'>FitnessLab is a workout tracking tool. Add workouts, create your own customized workout plans or find suitable plan from other users.<br /><span style={{ cursor: "pointer" }} onClick={() => window.open("https://zen-thompson-d7975f.netlify.app")} className='link_pro_'>Netlify</span>, <span style={{ marginTop: "10px", marginBottom: "10px", cursor: "pointer" }} onClick={() => window.open("https://github.com/anujgiri20/fitness_webite_")} className='link_pro_'>Frontend github</span>, <span style={{ cursor: "pointer" }} onClick={() => window.open("https://github.com/anujgiri20/fitness_backend")}>Backend github</span></p>
            <p className="pro_des"><span><img src={key} style={{width:"15px"}} /></span><span> user12 </span> <span> / 12345</span></p>
            </div>

            <div className='img_tech_div'>
              <img className='img_tech' src={html} />
              <img className='img_tech' src={css} />
              <img className='img_tech' src={react} />
              <img className='img_tech' src={mongo} />
           
              
              <img className='img_tech' src={nodejs} />
              <img className='img_tech' style={{borderRadius:"32.5px"}} src={ex} />
              
            </div>
            


          </div>
          <div className='div_img'>
            <img onClick={() => window.open("https://zen-thompson-d7975f.netlify.app")} className='project_imges' src={img1} />
          </div>

        </div>
       
        <div className='project'>
          <div className='pro_div'>
            <h1 className='pro_title'>Google Drive(Full Stack)</h1>
            <div>
              <p className='pro_des'>Google Drive is a cloud-based storage solution that allows you to save files online and access them anywhere from any smartphone, tablet, or computer.<br /><span style={{ cursor: "pointer" }} className='link_pro_' onClick={() => window.open("https://agitated-swanson-45d0d7.netlify.app")}>Netlify</span>, <span className='link_pro_' onClick={() => window.open("https://github.com/anujgiri20/googledrive")} style={{ cursor: "pointer" }}   >Frontend github</span>, <span style={{ cursor: "pointer" }} className='link_pro_' onClick={() => window.open("https://github.com/anujgiri20/drive_back")}>Backend github</span></p>
              <p className="pro_des"><span><img src={key} style={{width:"15px"}} /></span><span> user12 </span> <span> / 12345</span></p>
            </div>
            <div className='img_tech_div' style={{paddingBottom:"5px"}}>
            <img className='img_tech' src={html} />
              <img className='img_tech' src={css} />
              <img className='img_tech' src={react} />
              <img className='img_tech' src={fire} />
              <img className='img_tech' src={mongo} />
           
              <img className='img_tech' src={ui} />
              <img className='img_tech' src={nodejs} />
              <img className='img_tech' style={{borderRadius:"32.5px"}} src={ex} />
              
            </div>


          </div>
          <div className='div_img'>
            <img onClick={() => window.open("https://agitated-swanson-45d0d7.netlify.app")} className='project_imges' src={drive} />
          </div>

        </div>

        <div className='project'>
          <div className='pro_div'>
            <h1 className='pro_title'>Google meet(Full Stack)</h1>
            <div>
              <p className='pro_des'>Google meet is enterprise-grade video conferencing available to everyone.anyone with a Google Account can create an online meeting.<br /><span style={{ cursor: "pointer" }} onClick={() => window.open("https://reverent-perlman-05f62.netlify.app")} className='link_pro_'>Netlify</span>, <span style={{ marginTop: "10px", marginBottom: "10px", cursor: "pointer" }} onClick={() => window.open("https://github.com/anujgiri20/meet")} className='link_pro_'>Frontend github</span>, <span style={{ cursor: "pointer" }} onClick={() => window.open("https://github.com/anujgiri20/meet_back")}>Backend github</span></p>
              <p className="pro_des"><span><img src={key} style={{width:"15px"}} /></span><sapn> Google login</sapn></p>
            </div>

            <div className='img_tech_div'>
              <img className='img_tech' src={html} />
              <img className='img_tech' src={css} />
              <img className='img_tech' src={react} />
              <img className='img_tech' src={fire} />
              <img className='img_tech' src={redux} />
              <img className='img_tech' src={ui} />
              <img className='img_tech' src={nodejs} />
            </div>
          </div>
          <div className='div_img'>
            <img onClick={() => window.open("https://reverent-perlman-05f62.netlify.app")} className='project_imges' src={meet} />
          </div>

        </div>
       
        
        <div className='project'>
          <div className='pro_div'>
            <h1 className='pro_title'>Game hub(Full Stack)</h1>
           
            <div>
              <p className='pro_des'>Game hub contain variety of games like tic-tac-toe, stone-paper-scissor.game hub provides multiplayer and single player game.<br /><span style={{ cursor: "pointer" }} className='link_pro_' onClick={() => window.open("https://quirky-jepsen-b775ed.netlify.app")}>Netlify</span>, <span style={{ cursor: "pointer" }} className='link_pro_' onClick={() => window.open("https://github.com/anujgiri20/game_frontend")}>Frontend github</span>, <span style={{ cursor: "pointer" }} className='link_pro_' onClick={() => window.open("https://github.com/anujgiri20/gamebackend")}>Backend github</span></p>
              <p className="pro_des"><span><img src={key} style={{width:"15px"}} /></span><span> user12 </span> <span> / 12345</span></p>
            </div>


            <div className='img_tech_div'>
            <img className='img_tech' src={html} />
              <img className='img_tech' src={css} />
              <img className='img_tech' src={react} />
              <img style={{borderRadius:"32.5px"}} className='img_tech' src={ex} />
              <img className='img_tech' src={nodejs} />
              <img className='img_tech' src={mongo} />
            </div>


          </div>
          <div className='div_img'>
            <img onClick={() => window.open("https://quirky-jepsen-b775ed.netlify.app")} className='project_imges' src={gamehub} />
          </div>

        </div>
        <div className='project'>
          <div className='pro_div'>
            <h1 className='pro_title'>Insta Website(Full Stack)</h1>
          
            <div>
              <p className='pro_des'>In user app you can add, delete, update userdata along with login and authentication with jwt token verification.<br /><span style={{ cursor: "pointer" }} onClick={() => window.open("https://elated-mirzakhani-43eab3.netlify.app")} className='link_pro_'>Netlify</span>, <span style={{ cursor: "pointer" }} className='link_pro_' onClick={() => window.open("https://github.com/anujgiri20/_INSTAFRONT_")}>Github Frontend</span>, <span style={{ cursor: "pointer" }} className='link_pro_' onClick={() => window.open("https://github.com/anujgiri20/Insta_pro_backend")}>Github Backend</span></p>
              <p className="pro_des"><span><img src={key} style={{width:"15px"}} /></span><span> user12 </span> <span> / 12345</span></p>
             </div>


            <div className='img_tech_div'>
              <img className='img_tech' src={html} />
              <img className='img_tech' src={css} />
              <img className='img_tech' src={react} />
              <img style={{borderRadius:"32.5px"}} className='img_tech' src={ex} />
              <img className='img_tech' src={nodejs} />
              <img className='img_tech' src={mongo} />
            </div>



          </div>
          <div className='div_img'>
            <img onClick={() => window.open("https://elated-mirzakhani-43eab3.netlify.app")} className='project_imges' src={insta} />
          </div>

        </div>



        {/* <div className='project'>
          <div className='pro_div'>
            <h1 className='pro_title'>Pomodoro Clock</h1>
            <div>
              <p className='pro_des'>The Pomodoro Technique is a time management method developed by Francesco Cirillo in the late 1980s.It uses a timer to break work into intervals, traditionally 25 minutes in length, separated by short breaks.Created with Reactjs.<br /><span style={{ cursor: "pointer" }} className='link_pro_' onClick={() => window.open("https://lucid-mcnulty-49dc2f.netlify.app")}>Netlify</span>, <span onClick={() => window.open("https://github.com/anujgiri20/pomodorofrontend")} className='link_pro_' style={{ cursor: "pointer" }} >Fronend github</span></p>
            </div>


            <div className='img_tech_div'>
              <img className='img_tech' src={html} />
              <img className='img_tech' src={css} />
              <img className='img_tech' src={react} />
          
            </div>

          </div>
          <div className='div_img'>
            <img onClick={() => window.open("https://lucid-mcnulty-49dc2f.netlify.app")} className='project_imges' src={img3} />
          </div>

        </div> */}
        {/* <div className='project'>
          <div className='pro_div'>
            <h1 className='pro_title'>project name</h1>
          
            <p className='pro_des'>I am MERN Stack Developer from India. I enthusiastically follow the evolution of many languages, cloud services, and tools and stay on top of best practices.<br /><span className='link_pro_'>github</span> <span className='link_pro_'>netlify</span></p>

          </div>
          <div className='div_img'>
            <img className='project_imges' src={cert} />
          </div>
          
        </div> */}
        <div className='project'>
          <div className='pro_div'>
            <h1 className='pro_title'>Netflix Clone</h1>
            <div>
              <p className='pro_des'>Netflix clone created with Reactjs for frontend with movies Api<br /><span style={{ cursor: "pointer" }} onClick={() => window.open("https://mystifying-shockley-352398.netlify.app")} className='link_pro_'>Netlify</span>, <span style={{ cursor: "pointer" }} className='link_pro_' onClick={() => window.open("https://github.com/anujgiri20/netflix_project")}>Github frontend</span></p>
            </div>

            <div className='img_tech_div'>
              <img className='img_tech' src={html} />
              <img className='img_tech' src={css} />
              <img className='img_tech' src={react} />
             
            </div>



          </div>
          <div className='div_img'>
            <img onClick={() => window.open("https://mystifying-shockley-352398.netlify.app")} className='project_imges' src={img4} />
          </div>

        </div>


      </div>
    </>
  );
};

export default MyWork;
